export type DockPosition = 'left' | 'right' | 'bottom';

export const getDockKeys = (userId: string) => ({
  iconPanels: `dockIconPanels_${userId}`,
  pinnedBottom: `dockPinned_${userId}`,
  pinnedLeft: `dockPinnedLeft_${userId}`,
  pinnedRight: `dockPinnedRight_${userId}`,
});

export const readDockIconPanels = (userId: string): Record<string, DockPosition> => {
  try {
    const saved = localStorage.getItem(getDockKeys(userId).iconPanels);
    return saved ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
};

export const readDockPinned = (userId: string): Record<DockPosition, boolean> => {
  const keys = getDockKeys(userId);
  return {
    bottom: localStorage.getItem(keys.pinnedBottom) === 'true',
    left: localStorage.getItem(keys.pinnedLeft) === 'true',
    right: localStorage.getItem(keys.pinnedRight) === 'true',
  };
};

export const saveDockIconPanels = (userId: string, panels: Record<string, DockPosition>) => {
  localStorage.setItem(getDockKeys(userId).iconPanels, JSON.stringify(panels));
};

export const saveDockPinned = (userId: string, pos: DockPosition, value: boolean) => {
  const keys = getDockKeys(userId);
  const keyMap: Record<DockPosition, string> = {
    bottom: keys.pinnedBottom,
    left: keys.pinnedLeft,
    right: keys.pinnedRight,
  };
  localStorage.setItem(keyMap[pos], String(value));
};

export const getAllDockStorageKeys = (userId: string): string[] => {
  const k = getDockKeys(userId);
  return [k.iconPanels, k.pinnedBottom, k.pinnedLeft, k.pinnedRight];
};
